import { FetchGuestNotificationsQuery } from '@website/types/graphqlOperations';

/**
 *
 * composeNotificationActorsPrefix
 *
 * Takes activity actors and composes a message prefix with the number of actors
 * in a batched activity.
 *
 * For example:
 *
 * When there is just 1 unique actor, it returns the actor name e.g. Actor 1
 *
 * When there are just 2 actors, it returns their names separated by an add e.g.
 * Actor 1 and Actor 2.
 *
 * For more than 2 actors, it returns the first actor and then the number of the
 * remaining actors e.g. 4 actors will be Actor 1 and 3 others.
 *
 */
export default function composeNotificationActorsPrefix(
  activities: Pick<
    FetchGuestNotificationsQuery['user']['notifications']['items'][0],
    'actor'
  >[],
) {
  const ids = activities.map((activity) => activity.actor.id);
  const filterDuplicateActors = activities.filter(
    ({ actor }, index) => !ids.includes(actor.id, index + 1),
  );
  if (filterDuplicateActors.length === 1) {
    return `${filterDuplicateActors[0].actor.name}`;
  }
  if (filterDuplicateActors.length === 2) {
    return `${filterDuplicateActors[0].actor.name} and ${filterDuplicateActors[1].actor.name}`;
  }
  const othersTotal = filterDuplicateActors.length - 1;
  return `${filterDuplicateActors[0].actor.name} and ${othersTotal} others`;
}
